import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo/Logo-Cork-Matters.png";
import logoWhite from "../assets/logo/Logo-Cork-Matters-white.png";
import { BiSolidDownArrow } from "react-icons/bi";
import { ShopContext } from "../context/ShopContext";
import { AiOutlineClose } from "react-icons/ai";
import { IoBagOutline } from "react-icons/io5";
import { IoSearchOutline } from "react-icons/io5";

import "./Navbar.css";

function Navbar({ title, bannerText, theme }) {
  const { getTotalCartItemCount } = useContext(ShopContext);
  const [isCartIconAdded, setCartIconAdded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);
  const [animateCloseBannerOut, setAnimateCloseBannerOut] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  if (theme === "null") {
    theme = "light";
  }

  useEffect(() => {
    if (getTotalCartItemCount() > 0) {
      setCartIconAdded(true);

      setTimeout(() => {
        setCartIconAdded(false);
      }, 500);
    }
  }, [getTotalCartItemCount]);

  const handleCloseBanner = () => {
    setAnimateCloseBannerOut(true);
    setTimeout(() => setBannerVisible(false), 500);
  };

  return (
    <div className={`navbar ${menuOpen ? "active" : ""}`}>
      <div className="black-bar"></div>
      <div
        className={`${theme === "dark" ? "dark-theme-navbar" : ""} navbar-main`}
      >
        <div className="navbar-left">
          <div className="navbar-logo">
            {(theme === "light" || theme === undefined) && (
              <Link to="/">
                <img src={logo} alt="Cork Matters Logo" />
              </Link>
            )}
            {theme === "dark" && (
              <Link to="/">
                <img src={logoWhite} alt="Cork Matters Logo - White" />
              </Link>
            )}
          </div>
          <div
            className={`${
              theme === "dark" ? "dark-theme-navbar-links" : ""
            } navbar-links`}
          >
            <Link to="/">Home</Link>
            <Link to="/about">About us</Link>
            <Link to="/news">News</Link>
            <Link to="/cork">Cork</Link>
            <Link to="/project">Your Project</Link>
            <Link to="/downloads">Downloads</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/shop" style={{ color: "red" }}>
              Shop <BiSolidDownArrow />
            </Link>
          </div>
        </div>
        <div
          className={`${
            theme === "dark" ? "dark-theme-text" : ""
          } search-basket`}
        >
          
          <Link to="/">
            <span
              className={`${
                theme === "dark" ? "dark-theme-text" : ""
              } search-icon`}
            >
              <IoSearchOutline />
            </span>
          </Link>
          <Link to="/cart" className="cart-link">
            <span
              className={`cart-icon ${
                isCartIconAdded ? "cart-icon-added" : ""
              } ${theme === "dark" ? "dark-theme-text" : ""}`}
            >
              <IoBagOutline />
            </span>
            {getTotalCartItemCount() > 0 && (
              <span className="cart-item-count">{getTotalCartItemCount()}</span>
            )}
          </Link>
          <div className="menu-icon-container" onClick={toggleMenu}>
            <div className="menu-icon">
              <span
                className={`${
                  theme === "dark" ? "dark-theme-line" : ""
                } line-1`}
              ></span>
              <span
                className={`${
                  theme === "dark" ? "dark-theme-line" : ""
                } line-2`}
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          theme === "dark" ? "dark-theme-navbar-links-mobile" : ""
        } navbar-links-mobile`}
      >
        <Link to="/">HOME</Link>
        <Link to="/about">ABOUT US</Link>
        <Link to="/news">NEWS</Link>
        <Link to="/cork">CORK</Link>
        {/* <Link to="/project">YOUR PROJECT</Link> */}
        <Link to="/downloads">DOWNLOADS</Link>
        <Link to="/contact">CONTACT</Link>
        <Link to="/shop" style={{ color: "red" }}>
          SHOP <BiSolidDownArrow />
        </Link>
      </div>
      {title && (
        <div className="navbar-title">
          <p>{title}</p>
        </div>
      )}
      {bannerText && bannerVisible && (
        <div className={`navbar-text-banner ${animateCloseBannerOut ? "fade-out-up" : ""}`}>
        <div className="banner-text-container">
          <p className="banner-text-p">
            {bannerText}{" "}
            <a className="navbar-link-banner" href="/delivery"> See when to order</a>{" "}
            <a className="arrow-banner" href="/delivery">{" >"}</a>
          </p>
        </div>
        <AiOutlineClose
          className="close-button-banner"
          onClick={handleCloseBanner}
        />
      </div>
      )}
      {/* {!bannerVisible && <div className="spacer off-white"></div>} */}
    </div>
  );
}

export default Navbar;
